import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { getFundOpeningBalance, saveFundOpeningBalance } from '../../../api/ClubFundAPI'; // You'll need to add these
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';

const FundOpeningBalancePage = () => {
    const [formData, setFormData] = useState({
        amount: '',
        date: new Date().toISOString().slice(0, 10),
        remarks: 'Opening Balance',
    });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        getFundOpeningBalance((response) => {
            if (response.opening_balance) {
                const ob = response.opening_balance;
                setFormData({
                    amount: ob.amount,
                    date: new Date(ob.transaction_date).toISOString().slice(0, 10),
                    remarks: ob.description,
                });
            }
            setIsLoading(false);
        });
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        setIsSaving(true);
        saveFundOpeningBalance(formData, (response) => {
            setIsSaving(false);
            if (response.message) {
                Swal.fire('Success!', response.message, 'success');
            } else {
                setErrors(response?.response?.data?.errors || {});
                Swal.fire('Error!', 'Could not save the opening balance.', 'error');
            }
        });
    };

    if (isLoading) return <div className="text-center p-5"><div className="spinner-border"></div></div>;

    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title="Club Fund Opening Balance" />
                <div className="card">
                    <div className="card-header">
                        <h5>Set Initial Fund Balance</h5>
                        <p className="text-muted">This should be a one-time setup action to record the starting balance of your club's central fund.</p>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Opening Balance Date *</label>
                                <input type="date" className="form-control" name="date" value={formData.date} onChange={handleInputChange} />
                                {errors.date && <div className="text-danger small">{errors.date}</div>}
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Opening Balance Amount (₹) *</label>
                                <input type="number" className="form-control" name="amount" value={formData.amount} onChange={handleInputChange} />
                                {errors.amount && <div className="text-danger small">{errors.amount}</div>}
                            </div>
                            <div className="col-12 mb-3">
                                <label className="form-label">Remarks</label>
                                <input type="text" className="form-control" name="remarks" value={formData.remarks} onChange={handleInputChange} />
                            </div>
                        </div>
                    </div>
                    <div className="card-footer text-end">
                        <button className="btn btn-primary" onClick={handleSubmit} disabled={isSaving}>
                            {isSaving ? 'Saving...' : 'Save Opening Balance'}
                        </button>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default FundOpeningBalancePage;
